module.exports = __webpack_public_path__ + "img/huawei-1.824aab3d.png";